import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { TrialUserStore, TrialUserState } from './trial-user.store';

@Injectable({ providedIn: 'root' })
export class TrialUserQuery extends QueryEntity<TrialUserState> {
  allUsers$ = this.selectAll();

  constructor(protected store: TrialUserStore) {
    super(store);
  }
}
